<app-loader *ngIf="isDisabled || isPageDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="RegularizationPoliciesForm" (ngSubmit)="Validate(RegularizationPoliciesForm)"
        #RegularizationPoliciesForm="ngForm" novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Regularization Policy
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="RegularizationRuleTitle" class="form-label text-label-dark">Policy Name
                                :</label>
                        </div>
                        <div class="col-md-5">
                            <input type="text" class="form-control text-label-light" placeholder="Ex. Policy Name"
                                id="RegularizationRuleTitle" name="RegularizationRuleTitle"
                                [(ngModel)]="RegularizationRuleDetail.RegularizationRuleTitle"
                                #RegularizationRuleTitle="ngModel" maxlength="100" required>
                            <div class="invalid-feedback">
                                Please Enter Policy Name!
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="IsRegularizationForFutureDate" class="form-label text-label-dark">Regularization
                                allow for
                                future date :</label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.RegularizationPolicy.Regularizationallowforfuturedate"></i>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="IsRegularizationForFutureDate"
                                        [(ngModel)]="RegularizationRuleDetail.IsRegularizationForFutureDate"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="IsRegularizationForFutureDate"
                                        [(ngModel)]="RegularizationRuleDetail.IsRegularizationForFutureDate"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row mb-3">
                        <div class="col-md-auto align-self-top">
                            <label class="form-label text-label-dark">Regularization request can be raised</label>
                        </div>
                        <div class="col-md-2" style="width: 115px;">
                            <input type="number" min="0" max="365"
                                oninput="this.value = Math.floor(Math.abs(this.value))"
                                class="form-control text-label-light" placeholder="Ex. 01"
                                id="TillDateRequestForRegularization" name="TillDateRequestForRegularization"
                                [(ngModel)]="RegularizationRuleDetail.TillDateRequestForRegularization"
                                #TillDateRequestForRegularization="ngModel" required>
                            <div class="invalid-feedback">
                                Please enter max 365 days!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-top">
                            <label class="form-label text-label-dark">Day's from the date to be regularized</label>
                        </div>
                    </div> -->

                    <div class="row mb-3">
                        <div class="col-md-auto align-self-top">
                            <label class="form-label text-label-dark">Regularization request can be raised</label>
                        </div>
                        <div class="col-md-2" style="width: 115px;">
                            <input type="text" maxlength="3" pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                                class="form-control text-label-light"
                                [ngClass]="{'ng-invalid': common.parseFloat(RegularizationRuleDetail.TillDateRequestForRegularization) > 365}"
                                placeholder="Ex. 01" id="TillDateRequestForRegularization"
                                name="TillDateRequestForRegularization"
                                [(ngModel)]="RegularizationRuleDetail.TillDateRequestForRegularization"
                                #TillDateRequestForRegularization="ngModel" required>
                            <div class="invalid-feedback">
                                Please enter max 365 days!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-top">
                            <label class="form-label text-label-dark">Day's from the date to be regularized</label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.RegularizationPolicy.Regularizationrequestcanberaised"></i>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-md-auto align-self-top">
                            <label class="form-label text-label-dark">Allow for</label>
                        </div>
                        <div class="col-md-2" style="width: 115px;">
                            <!-- <input type="number" min="0" oninput="this.value = Math.floor(Math.abs(this.value))"
                                class="form-control text-label-light" placeholder="Ex. 01"
                                id="AllowRegularizationForDays" name="AllowRegularizationForDays"
                                [(ngModel)]="RegularizationRuleDetail.AllowRegularizationForDays"
                                #AllowRegularizationForDays="ngModel" required> -->
                            <input type="text" maxlength="5" pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)"
                                class="form-control text-label-light" placeholder="Ex. 01"
                                id="AllowRegularizationForDays" name="AllowRegularizationForDays"
                                [(ngModel)]="RegularizationRuleDetail.AllowRegularizationForDays"
                                #AllowRegularizationForDays="ngModel">
                        </div>
                        <div class="col-md-auto align-self-top">
                            <!-- <label class="form-label text-label-dark">Day's</label> -->
                            <label class="form-label text-label-dark">time(s)</label>
                        </div>
                        <div class="col-md-3">
                            <select class="form-select text-label-light" aria-label="AllowRegularizationFor"
                                placeholder="AllowRegularizationFor" title="AllowRegularizationFor"
                                name="AllowRegularizationFor"
                                [(ngModel)]="RegularizationRuleDetail.AllowRegularizationFor"
                                #AllowRegularizationFor="ngModel" required>
                                <option disabled [value]=null>--Select Period--</option>
                                <option *ngFor="let PeriodType of common.PeriodTypes" [value]=PeriodType.Value>
                                    {{PeriodType.Name}}</option>
                            </select>
                            <div class="invalid-feedback">
                                Please select regularization for!
                            </div>
                        </div>
                        <div class="col-md-auto"><i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.RegularizationPolicy.Allowfor"></i></div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="AllowRegularizationForSameDays" class="form-label text-label-dark">Allow
                                regularization for same
                                date :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="AllowRegularizationForSameDays"
                                        [(ngModel)]="RegularizationRuleDetail.AllowRegularizationForSameDays"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.RegularizationPolicy.AllowregularizationforsamedateYES"></i>
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="AllowRegularizationForSameDays"
                                        [(ngModel)]="RegularizationRuleDetail.AllowRegularizationForSameDays"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.RegularizationPolicy.AllowregularizationforsamedateNO"></i>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center">
                            <label for="AllowRegulariationForPreviousMonth" class="form-label text-label-dark">Allow
                                regularization for previous
                                month :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="AllowRegulariationForPreviousMonth"
                                        [(ngModel)]="RegularizationRuleDetail.AllowRegulariationForPreviousMonth"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.RegularizationPolicy.AllowregularizationforpreviousdateYES"></i>
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="AllowRegulariationForPreviousMonth"
                                        [(ngModel)]="RegularizationRuleDetail.AllowRegulariationForPreviousMonth"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                    <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                        [ngbTooltip]="tooltip.RegularizationPolicy.AllowregularizationforpreviousdateNO"></i>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">Allow Request After Monthlock :
                            </label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"></i>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="AllowRequestAfterMonthlock"
                                        [(ngModel)]="RegularizationRuleDetail.AllowRequestAfterMonthlock"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="AllowRequestAfterMonthlock"
                                        [(ngModel)]="RegularizationRuleDetail.AllowRequestAfterMonthlock"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto">
                            <label for="EmpType" class="form-label text-label-dark">Employee Type :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.RegularizationRuleDetail.ESS_RegularizationRuleID == 0) || (this.RegularizationRuleDetail.ESS_RegularizationRuleID > 0 && common.ToLowerCase(RegularizationRuleDetail.EmpType) == 'front')">
                                    <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                        [(ngModel)]="RegularizationRuleDetail.EmpType"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="RegularizationRuleDetail.ESS_RegularizationRuleID > 0"
                                        (change)="GetApplicability()" required>
                                    Front Office
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.RegularizationRuleDetail.ESS_RegularizationRuleID == 0) || (this.RegularizationRuleDetail.ESS_RegularizationRuleID > 0 && common.ToLowerCase(RegularizationRuleDetail.EmpType) == 'back')">
                                    <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                        [(ngModel)]="RegularizationRuleDetail.EmpType"
                                        [ngModelOptions]="{standalone: true}"
                                        [disabled]="RegularizationRuleDetail.ESS_RegularizationRuleID > 0"
                                        (change)="GetApplicability()" required>
                                    Back Office
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto align-self-center me-2">
                            <label for="DefaultRegularization" class="form-label text-label-dark">Default Policy
                                :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="DefaultRegularization"
                                        [(ngModel)]="RegularizationRuleDetail.DefaultRegularization"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="DefaultRegularization"
                                        [(ngModel)]="RegularizationRuleDetail.DefaultRegularization"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID'
                                        [(ngModel)]="RegularizationRuleDetail.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()"
                                        [disabled]="Applicability.WebESSApplicabilityMasterID == 0 && RegularizationRuleDetail.DefaultRegularization">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && RegularizationRuleDetail.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>
                <button
                    *ngIf="(this.common.PageRight.IsAdd && this.RegularizationRuleDetail.ESS_RegularizationRuleID == 0) || (this.common.PageRight.IsEdit && this.RegularizationRuleDetail.ESS_RegularizationRuleID > 0)"
                    type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>